// Level1.js
import React from 'react';
import { AnimatePresence } from 'framer-motion';
import PlayLevel1 from './1PlayLevel1';
import PlayLevel1Fashion from './PlayLevel1Fashion';
import PlayLevel1Product from './PlayLevel1Product';

const Level1 = ({ onWin, onLose, trainingType }) => {
  const handleLevelComplete = (images) => {
    onWin(images);
  };

  const renderLevel1Component = () => {
    switch(trainingType) {
      case 'fashion':
        return (
          <PlayLevel1Fashion 
            key="level-1-fashion"
            onWin={handleLevelComplete}
            onLose={onLose}
            trainingType={trainingType}
          />
        );
      case 'product':
        return (
          <PlayLevel1Product
            key="level-1-product"
            onWin={handleLevelComplete}
            onLose={onLose}
            trainingType={trainingType}
          />
        );
      default:
        return (
          <PlayLevel1 
            key="level-1"
            onWin={handleLevelComplete}
            onLose={onLose}
            trainingType={trainingType}
          />
        );
    }
  };

  return (
    <AnimatePresence mode="wait">
      {renderLevel1Component()}
    </AnimatePresence>
  );
};

export default Level1;